<template>
  <button class="transition-all p-3 rounded-full border border-black bg-transparent hover:bg-blue-500 hover:text-white hover:border-blue-500 active:bg-blue-600 active:border-blue-600 active:text-white disabled:bg-transparent disabled:border-gray-400 disabled:text-gray-400">
    <svg class="w-5 h-5"
         :class="{'transform rotate-180': direction === 'left'}"
         viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5029 0.630615L9.15266 2.01359L16.9482 9.62481L0 9.6635V11.5977L16.974 11.559L9.23323 19.2605L10.5964 20.6306L20 11.2754L19.9968 9.89883L10.5029 0.630615Z" fill="currentColor"/>
    </svg>
  </button>
</template>

<script>
export default {
  props: ['direction'],
}
</script>
